// React
import React, { useState } from "react";

// Libraries
import PropTypes from "prop-types";
import { Sidebar } from "semantic-ui-react";

// Redux
import { connect } from "react-redux";
import toggleSidebar from "@Actions/menu";

// Components
import Header from "@Components/Header";
import SideBar from "@Components/SideBar";

// Hooks
import usePanelVisibility from "@Hooks/usePanelVisibility";

// Styles
import styles from "./styles.module.css";

const Screen = ({ dispatch, children, hasHeader = false, hasSidebar = false, headerTitle = "", isExtended }) => {
	const { isMobileOrTablet } = usePanelVisibility();
	const [isVisible, setIsVisible] = useState(false);

	const handleToggle = () => {
		if (isMobileOrTablet) {
			setIsVisible((prev) => {
				return !prev;
			});
		} else {
			dispatch(toggleSidebar());
		}
	};

	return (
		<div className={styles.screen}>
			{hasHeader && <Header headerTitle={headerTitle} handleToggle={handleToggle} />}
			<div className={hasHeader ? styles.bodyWithHeader : styles.body}>
				{hasSidebar && (
					<Sidebar.Pushable className={styles.pushable}>
						<SideBar
							handleToggle={handleToggle}
							isExtended={isMobileOrTablet ? true : isExtended}
							isMobileOrTablet={isMobileOrTablet}
							isVisible={isMobileOrTablet ? isVisible : true}
						/>
						<Sidebar.Pusher className={isMobileOrTablet ? styles.pushable : isExtended ? styles.pusher : styles.collapsedPusher}>
							<div className={styles.content}>{children}</div>
						</Sidebar.Pusher>
					</Sidebar.Pushable>
				)}
				{!hasSidebar && children}
			</div>
		</div>
	);
};

Screen.propTypes = {
	dispatch: PropTypes.func,
	children: PropTypes.node,
	hasHeader: PropTypes.bool,
	hasSidebar: PropTypes.bool,
	headerTitle: PropTypes.string,
	isExtended: PropTypes.bool,
};

function mapStateToProps({ menu }) {
	return { isExtended: menu.isExtended };
}

export default connect(mapStateToProps)(Screen);
